// src/VisitCounter.jsx
import { useEffect, useState } from 'react';
import { initializeApp } from 'firebase/app';
import { getDatabase, ref, runTransaction } from 'firebase/database';

// ✅ Replace with your Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyAsLU4u1oYIWn4mwn18RLE1Ar_oEqXGF1o",
  authDomain: "visit-counter-4de8c.firebaseapp.com",
  databaseURL: "https://visit-counter-4de8c-default-rtdb.asia-southeast1.firebasedatabase.app", // ✅ Added this
  projectId: "visit-counter-4de8c",
  storageBucket: "visit-counter-4de8c.firebasestorage.app",
  messagingSenderId: "802617391288",
  appId: "1:802617391288:web:410672a44ca0c770931c4d",
  measurementId: "G-9ZGV17HMMJ"
};


const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

function VisitCounter() {
  const [visits, setVisits] = useState('Loading...');

  useEffect(() => {
    const countRef = ref(database, 'visitCount');

    runTransaction(countRef, (currentValue) => {
      return (currentValue || 0) + 1;
    }).then(({ snapshot }) => {
      setVisits(`Site Visits : ${snapshot.val()}`);
    }).catch((error) => {
      console.error('Error updating visit count:', error);
      setVisits('Error fetching count');
    });
  }, []);

  return <div>{visits}</div>;
}

export default VisitCounter;
